import React from 'react';
import { Chip } from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PhonelinkIcon from '@mui/icons-material/Phonelink';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { OPERATING_MODE_LABELS } from '../constants/operatingModes';

const CONFIG_BY_MODE = {
  PDV: { color: 'primary', icon: <StorefrontIcon fontSize="small" /> },
  STANDALONE: { color: 'success', icon: <PhonelinkIcon fontSize="small" /> },
  UNDEFINED: { color: 'default', icon: <HelpOutlineIcon fontSize="small" /> },
};

const EstadoModo = ({ mode }) => {
  const config = CONFIG_BY_MODE[mode] || CONFIG_BY_MODE.UNDEFINED;

  return (
    <Chip
      icon={config.icon}
      label={OPERATING_MODE_LABELS[mode] || mode || 'Sin definir'}
      color={config.color}
      size="small"
      variant="filled"
      sx={{ fontWeight: 500 }}
    />
  );
};

export default EstadoModo;
